/**
 * Colores y constantes compartidas del módulo Entregas
 */

export const FASES_COLORES = {
  'Liberación': '#9ca3af',
  'Inspección': '#2F5555',
  'Programación': '#5B7FA6',
  'Entrega': '#6AA1A0',
  'Levantamiento': '#C00002',
  'Cierre': '#96945C'
};

// Pares degradé para KPI cards (estilo Dashboard Postventa)
export const FASES_DEGRADADO = {
  'Liberación': { from: '#9ca3af', to: '#6b7280' },
  'Inspección': { from: '#2F5555', to: '#1a3636' },
  'Programación': { from: '#5B7FA6', to: '#3d5a7a' },
  'Entrega': { from: '#6AA1A0', to: '#4a7d7c' },
  'Levantamiento': { from: '#C00002', to: '#8a0001' },
  'Cierre': { from: '#96945C', to: '#6e6d3f' }
};

export const FASES_ORDEN = [
  'Liberación', 'Inspección', 'Programación',
  'Entrega', 'Levantamiento', 'Cierre'
];

export const getFaseColor = (fase) => FASES_COLORES[fase] || '#6B7280';

// Fases que tienen página dedicada para vista histórica
export const FASES_RUTAS = {
  'Inspección': (id) => `/entregas/${id}/inspeccion`,
  'Programación': (id) => `/entregas/${id}/programacion`,
};

// Helpers para unidad_principal (compatible JSONB y legacy text)
export const getUnidadCodigo = (entrega) => {
  const up = entrega?.unidad_principal;
  return (typeof up === 'object' && up) ? (up.codigo || '') : (up || '');
};

export const getUnidadTipo = (entrega) => {
  const up = entrega?.unidad_principal;
  return (typeof up === 'object' && up) ? (up.tipo_unidad || '') : (entrega?.tipo_unidad || '');
};

export const getUnidadNombre = (entrega) => {
  const up = entrega?.unidad_principal;
  return (typeof up === 'object' && up) ? (up.nombre || '') : '';
};

export const formatUnidadAsignada = (u) => {
  if (typeof u === 'string') return u;
  const parts = [u.tipo_unidad, u.codigo].filter(Boolean);
  if (u.nombre) parts.push(`(${u.nombre})`);
  return parts.join(': ') || '-';
};

export const TIPOS_UNIDAD = ['Departamento', 'Estacionamiento', 'Depósito', 'Local Comercial', 'Área Común'];
